module.exports = __webpack_public_path__ + "media/images/icon__externalLink@2x-5dd1538e692d5a345325c473b50be91c.png";